import { render, staticRenderFns } from "./PageVendorReleaseOrderInfo.vue?vue&type=template&id=60f649ea&scoped=true"
import script from "./PageVendorReleaseOrderInfo.vue?vue&type=script&lang=js"
export * from "./PageVendorReleaseOrderInfo.vue?vue&type=script&lang=js"
import style0 from "./PageVendorReleaseOrderInfo.vue?vue&type=style&index=0&id=60f649ea&prod&lang=css"
import style1 from "./PageVendorReleaseOrderInfo.vue?vue&type=style&index=1&id=60f649ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f649ea",
  null
  
)

export default component.exports